import React, { useMemo } from 'react';
import { Alert, Box } from '@mui/material';
import GameDialog from '../../../../components/games/GameDialog';
import GameTable from '../../../../components/games/GameTable';
import StateGamesHeader from '../components/StateGamesHeader';
import StateGamesStatus from '../components/StateGamesStatus';
import { useStateGamesPageLogic } from '../hooks/useStateGamesPageLogic';
import { adminAlertSx, adminAlertToneSx, adminCombineSx } from '../../../../styles/adminComponentStyles';

const StateGamesPage: React.FC = () => {
  const {
    games,
    loading,
    error,
    statesError,
    statesLoading,
    groupedStates,
    states,
    dialogOpen,
    dialogMode,
    selectedGame,
    selectedCountry,
    selectedCountryName,
    selectedStateId,
    selectedStateName,
    stateLabel,
    statesForSelectedCountry,
    isInvalidState,
    createLoading,
    updateLoading,
    clearError,
    handleCountryChange,
    handleStateSelect,
    handleCreateGame,
    handleUpdateGame,
    handleDialogClose,
    handleDialogSubmit,
    handleDownloadCsv,
  } = useStateGamesPageLogic();

  const dialogDefaultValues = useMemo(() => ({
    country_code: selectedCountry,
    country_name: selectedCountryName,
    state_code: selectedStateId,
    state_name: selectedStateName,
  }), [selectedCountry, selectedCountryName, selectedStateId, selectedStateName]);

  return (
    <Box>
      {statesError && (
        <Alert severity="error" sx={adminCombineSx(adminAlertSx, adminAlertToneSx.danger, { mb: 2 })}>
          {statesError}
        </Alert>
      )}

      {isInvalidState ? (
        <StateGamesStatus mode="invalid" statesLoading={statesLoading} />
      ) : (
        <>
          <StateGamesHeader
            stateLabel={stateLabel}
            totalGames={games.length}
            onCreateGame={handleCreateGame}
          />

          {error && (
            <Alert severity="error" sx={adminCombineSx(adminAlertSx, adminAlertToneSx.danger, { mb: 2 })} onClose={clearError}>
              {error}
            </Alert>
          )}

          {loading && <StateGamesStatus mode="loading" />}
          {!loading && games.length === 0 && <StateGamesStatus mode="empty" onCreateGame={handleCreateGame} />}
          {!loading && games.length > 0 && (
            <GameTable
              games={games}
              groupedStates={groupedStates}
              selectedCountry={selectedCountry}
              selectedStateId={selectedStateId}
              statesForSelectedCountry={statesForSelectedCountry}
              statesLoading={statesLoading}
              gamesLoading={loading}
              onCountryChange={handleCountryChange}
              onStateChange={handleStateSelect}
              onDownloadCsv={handleDownloadCsv}
              onUpdate={handleUpdateGame}
            />
          )}

          {dialogOpen && (
            <GameDialog
              open={dialogOpen}
              onClose={handleDialogClose}
              onSubmit={handleDialogSubmit}
              game={selectedGame}
              loading={createLoading || updateLoading}
              mode={dialogMode}
              defaultValues={dialogDefaultValues}
              states={states}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default StateGamesPage;
